import React, { Component } from 'react';
import Paragraph from '../../general/Paragraph';
import { Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import Header4 from '../../general/Header4';

export default class PrivacyPolicy extends Component {

    render() {
        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} backdrop={true} size="lg">
                    <ModalHeader toggle={this.toggle}>Souhlas se zpracováním osobních údajů</ModalHeader>
                    <ModalBody>
                        <Header4>Nadační fond Cesta ke hvězdám, IČO 04653793</Header4>
                        <Paragraph>
                            Tímto uděluji nadačnímu fondu Cesta ke hvězdám, IČO 04653793, se sídlem [doplnit adresu], jako správci osobních údajů, souhlas se zpracováním osobních údajů v následujícím rozsahu:
                            <ul>
                                <li>jméno a příjmení / název společnosti,</li>
                                <li>adresa (trvalého pobytu / sídla),</li>
                                <li>e-mailová adresa,</li>
                                <li>případně další údaje uvedené ve formuláři nezbytné k jednoznačné identifikaci daru.</li>
                            </ul>
                        </Paragraph>
                        <Paragraph>
                            Osobní údaje budou zpracovány výhradně za účelem:
                            <ol>
                                <li>evidence uskutečněných darů,</li>
                                <li>vystavení a zaslání potvrzení o daru pro daňové účely,</li>
                                <li>nezbytné komunikace související s identifikací daru.</li>
                            </ol>
                        </Paragraph>
                        <Paragraph>
                            Tento souhlas uděluji dobrovolně a na dobu 10 let od poskytnutí daru, nebo do doby, kdy souhlas odvolám.
                        </Paragraph>
                        <Paragraph>
                            Beru na vědomí, že mám práva stanovená nařízením (EU) 2016/679 (GDPR), zejména právo:
                            <ol>
                                <li>na přístup k osobním údajům,</li>
                                <li>na opravu nepřesných údajů,</li>
                                <li>na omezení zpracování nebo jejich výmaz,</li>
                                <li>na odvolání souhlasu kdykoliv, a to odesláním žádosti na adresu <a href="mailto:nadace@cestakehvezdam.cz">nadace@cestakehvezdam.cz</a>.</li>
                            </ol>
                            Správce prohlašuje, že osobní údaje bude zpracovávat v nezbytném rozsahu, v souladu s výše uvedeným účelem, a že údaje nebudou předávány třetím osobám, s výjimkou subjektů, které pro správce zajišťují technické nebo administrativní zpracování, a které mají s správcem uzavřenou smlouvu o zpracování osobních údajů.
                        </Paragraph>
                        <div className="text-center">
                            <Button className="gradient-bg" onClick={this.props.toggle}>Zavřít</Button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}